// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.right-block[data-v-6598546c] {\n  max-width: 40rem;\n}\n.info-maps[data-v-6598546c] {\n  padding-top: 50%;\n}\n.footer[data-v-6598546c] {\n  margin-left: 2.2rem;\n  margin-top: 1rem;\n}\n", ""]);
// Exports
module.exports = exports;
